import lineItemsReducer from 'src/features/LineItemsGridSlice';
import receiptReducer from 'src/features/ReceiptSlice';
import viewReceiptsReducer from 'src/features/ViewReceiptsSlice';

import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';

import invoiceGridReducer from 'src/features/InvoiceGridSlice';
import invoiceReducer from 'src/features/InvoiceSlice';
import poGridReducer from '../features/POGridSlice';
import receiptGridReducer from '../features/ReceiptGridSlice';

export const store = configureStore({
  reducer: {
    receipts: receiptGridReducer,
    pos: poGridReducer,
    viewReceipts: viewReceiptsReducer,
    lineItems: lineItemsReducer,
    receipt: receiptReducer,
    invoiceItems: invoiceGridReducer,
    invoice: invoiceReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
